module.exports = __webpack_public_path__ + "img/8.5ded2b4e.jpg";